<template>
  <div id="introduce-guideline">
    <section id="Tổng Quan">
      <h4>Tổng Quan Màn Hình Danh Sách Content</h4>
      <p>
        Màn hình chứa danh sách phim (content) được chia làm 2 loại là
        <b> single (phim lẻ) và season (phim bộ).</b>
        <br />
        Ở màn hình này user có thể
        <b>tìm kiếm </b> theo tên của
        <b>content / season</b>
        <br />
        Chọn 1 content hoặc 1 season bất kì để vào màn hình
        <b>details content</b>
      </p>
      <img src="../../assets/tutorial/screen-list-content.png" />
    </section>
    <v-divider></v-divider>
    <!-- <section class="mt-3" id="Thêm Content">
      <h4>Thêm content từ bên thứ 3</h4>
      <p>
        <span>
          Sử dụng button
          <v-btn color="success" outlined icon
            ><v-icon>{{ mdiPlus }}</v-icon></v-btn
          >
          để thêm 1 content / 1 season</span
        >
      </p>
      <div>
        <p>
          Sau khi nhấn vào button, màn hình sẽ hiển thị
          <b>popup</b>
        </p>

        <p>
          Người dùng nhập thông tin trên form và nhấn
          <b>create</b>
        </p>

        <br />
        <img src="../../assets/tutorial/popup-create-content.png" />
      </div>
    </section> -->
    <section class="mt-3" id="Hướng Dẫn Thêm Video trên Youtube">
      <h4>Video Hướng Dẫn Thêm Content</h4>
      <video width="400" controls>
        <source
          src="../../assets/tutorial/huong-dan-add-content.mp4"
          type="video/mp4"
        />
      </video>
    </section>
  </div>
</template>

<script>
import { call, sync } from "vuex-pathify";
import { mdiPlus } from "@mdi/js";
export default {
  data() {
    return {
      mdiPlus: mdiPlus,
    };
  },

  mounted() {
    let items = document.getElementById("introduce-guideline")?.childNodes;
    if (items) {
      let ids = Array.prototype.reduce.call(
        items,
        function (arr, elem) {
          arr.push(elem.id);
          return arr;
        },
        []
      );
      this.setListTitle([...ids]);
    }

    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    myAnchorTilte: sync("showcase/myAnchorTilte"),
  },
  methods: {
    setListTitle: call("showcase/setListTitle"),
    handleScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const sections = document.getElementById(
        "introduce-guideline"
      ).childNodes;
      let currentSectionIndex = 0;
      for (let i = 0; i < sections.length; i++) {
        const sectionTop = sections[i].offsetTop - 125;
        const sectionBottom = sectionTop + sections[i].offsetHeight;
        if (scrollTop >= sectionTop && scrollTop < sectionBottom) {
          currentSectionIndex = i;
          break;
        }
      }
      const currentSectionId = sections[currentSectionIndex].getAttribute("id");

      if (this.myAnchorTilte !== currentSectionId) {
        this.myAnchorTilte = currentSectionId;
        localStorage.setItem("myAnchorTilte", currentSectionId);
      }
    },
  },
};
</script>

<style></style>
